import { FinancialApplicationSection } from "@/types/enums";
import {
  ValidationErrorDisplayMode,
  ValidationErrorsCounts,
} from "../ValidationErrorsCounts";
import {
  FinancialApplicationFormSectionContextType,
  FinancialApplicationFormValidationDisplayBehavior,
  useFinancialApplicationFormSectionValidation,
} from "@/hooks/useFinancialApplicationFormSectionValidation";
import { useAtom } from "jotai";
import { bankerApplicationViewStateAtomFamily } from "@/atoms/bankerApplicationViewStateAtomFamily";
import { useSetAtom } from "jotai";
import { DomainValidationError } from "@/types/FinancialApplicationValidationState";

export interface BankerValidationErrorsBadgeProps {
  financialApplicationId: string;
  section: FinancialApplicationSection;
  renderZeroErrors?: boolean;
  // showErrorDetails?: boolean;
  label?: string;
  showNavigateToField?: boolean;
  showSectionTitle?: boolean;
  popoverClassName?: string;
  displayMode: ValidationErrorDisplayMode;
}

export const BankerValidationErrorsBadge = ({
  financialApplicationId,
  section,
  renderZeroErrors = false,
  // showErrorDetails = true,
  label,
  showNavigateToField = false,
  showSectionTitle = false,
  popoverClassName = "",
  displayMode = ValidationErrorDisplayMode.Remaining
}: BankerValidationErrorsBadgeProps) => {
  const [bankerApplicationViewStateAtom, ] = useAtom(bankerApplicationViewStateAtomFamily(financialApplicationId));
  const setFinancialApplicationSection = useSetAtom(bankerApplicationViewStateAtom.setFinancialApplicationSection);

  const { validationErrorsForSection, totalRequiredFieldCount } = useFinancialApplicationFormSectionValidation(
    financialApplicationId,
    section,
    FinancialApplicationFormValidationDisplayBehavior.AlwaysDisplayValidationErrors,
    FinancialApplicationFormSectionContextType.Banker
  );

  const navigateToField = (e: DomainValidationError) => {
    const sectionsCsv = e.customStateDictionary?.appliesToBankerSections;
    if (sectionsCsv) {
      const sections = sectionsCsv.split(",").map(Number);
      const firstSection = sections[0] as FinancialApplicationSection;
      setFinancialApplicationSection(firstSection);
    }
  };

  return (
    <ValidationErrorsCounts
      validationErrors={Object.values(validationErrorsForSection).flat()}
      displayMode={displayMode}
      // showErrorDetails={showErrorDetails}
      renderZeroErrors={renderZeroErrors}
      label={label}
      navigateToField={showNavigateToField ? navigateToField : undefined}
      showSectionTitle={showSectionTitle}
      popoverClassName={popoverClassName}
      totalRequiredFieldCount={totalRequiredFieldCount}
    />
  );
};
